import { render, staticRenderFns } from "./ManagementEntityStatsGame.vue?vue&type=template&id=7895c536&scoped=true&"
import script from "./ManagementEntityStatsGame.vue?vue&type=script&lang=js&"
export * from "./ManagementEntityStatsGame.vue?vue&type=script&lang=js&"
import style0 from "./ManagementEntityStatsGame.vue?vue&type=style&index=0&id=7895c536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895c536",
  null
  
)

export default component.exports